import MainPageFrame from '../../_common/elements/MainPageFrame';

function Contract() {
    const data = {
        title: 'Overview',
        address: '/contract',
    };
    return <MainPageFrame data={data} />;
}

export default Contract;
